var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.98047V4.48547H1V2.98047C1 2.15549 1.67499 1.48047 2.5 1.48047H4.25V2.96048C4.25 3.23547 4.47501 3.46048 4.75 3.46048C5.02499 3.46048 5.25 3.23547 5.25 2.96048V1.48047H10.75V2.96048C10.75 3.23547 10.975 3.46048 11.25 3.46048C11.525 3.46048 11.75 3.23547 11.75 2.96048V1.48047H13.5C14.325 1.48047 15 2.15549 15 2.98047Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.4922H14.695L10.5 14.2322V10.9922C10.5 10.7172 10.725 10.4922 11 10.4922Z",
    fill: "#8E8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.48438V9.48938H11C10.175 9.48938 9.5 10.1644 9.5 10.9894V14.4994H2.5C1.67499 14.4994 1 13.8244 1 12.9994V5.48438H15Z",
    fill: "#8E8E8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1V1.47998H4.25V1C4.25 0.725006 4.47501 0.5 4.75 0.5C5.02499 0.5 5.25 0.725006 5.25 1Z",
    fill: "#8E8E8E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1V1.47998H10.75V1C10.75 0.725006 10.975 0.5 11.25 0.5C11.525 0.5 11.75 0.725006 11.75 1Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetDelivery);
export default __webpack_public_path__ + "static/media/TargetDelivery.26d4fbd6df26650487c832a879bea724.svg";
export { ForwardRef as ReactComponent };